module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Bold.b0cf4ab.woff";